// extracted by mini-css-extract-plugin
export var dropdownContainer = "_pv-0";
export var leftAlign = "_pv-4";
export var listItem = "_pv-2";
export var listItemWrapper = "_pv-1";
export var operationText = "_pv-3";